// FETCH ALL PROPERTIES FROM DYEING_DC DETAILS
export const FETCH_DYEING_DC_DETAILS_REQUEST = 'FETCH_DYEING_DC_DETAILS_REQUEST';
export const FETCH_DYEING_DC_DETAILS_SUCCESS = 'FETCH_DYEING_DC_DETAILS_SUCCESS';
export const FETCH_DYEING_DC_DETAILS_FAILURE = 'FETCH_DYEING_DC_DETAILS_FAILURE';

export const FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_REQUEST = 'FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_REQUEST';
export const FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_SUCCESS = 'FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_SUCCESS';
export const FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_FAILURE = 'FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_FAILURE';

export const FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_REQUEST = 'FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_REQUEST';
export const FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS = 'FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS';
export const FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_FAILURE = 'FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_FAILURE';

export const FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST = 'FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST';
export const FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS = 'FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS';
export const FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE = 'FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE';

// FETCH ALL PROPERTIES FROM DYEING_DC DETAILS
export const FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST = 'FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST';
export const FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS = 'FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS';
export const FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE = 'FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE';

// FETCH ALL PROPERTIES FROM DYEING_DC DETAILS BY ID
export const FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST = 'FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE = 'FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR DYEING_DC DETAILS
export const CREATE_DYEING_DC_DETAILS_REQUEST = 'CREATE_DYEING_DC_DETAILS_REQUEST';
export const CREATE_DYEING_DC_DETAILS_SUCCESS = 'CREATE_DYEING_DC_DETAILS_SUCCESS';
export const CREATE_DYEING_DC_DETAILS_FAILURE = 'CREATE_DYEING_DC_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_DYEING_DC_DETAILS = 'CREATE_USER_FORM_DYEING_DC_DETAILS';

// UPDATE PROPERTIES FOR DYEING_DC DETAILS
export const UPDATE_DYEING_DC_DETAILS_REQUEST = 'UPDATE_DYEING_DC_DETAILS_REQUEST';
export const UPDATE_DYEING_DC_DETAILS_SUCCESS = 'UPDATE_DYEING_DC_DETAILS_SUCCESS';
export const UPDATE_DYEING_DC_DETAILS_FAILURE = 'UPDATE_DYEING_DC_DETAILS_FAILURE';

// FETCH SINGLE DYEING_DC_DETAILS
export const FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST = 'FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE = 'FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR DYEING_DC DETAILS
export const DELETE_DYEING_DC_DETAILS_REQUEST = 'DELETE_DYEING_DC_DETAILS_REQUEST';
export const DELETE_DYEING_DC_DETAILS_SUCCESS = 'DELETE_DYEING_DC_DETAILS_SUCCESS';
export const DELETE_DYEING_DC_DETAILS_FAILURE = 'DELETE_DYEING_DC_DETAILS_FAILURE';

export const FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST = 'FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE = 'FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE';

// USERFORM RESET

export const DYEING_DC_DETAILS_USERFORM_RESET = 'DYEING_DC_DETAILS_USERFORM_RESET';

export const FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_REQUEST = 'FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_REQUEST';
export const FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_SUCCESS = 'FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_SUCCESS';
export const FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_FAILURE = 'FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_FAILURE';

export const SHOW_PREVIOUS_LIST = 'SHOW_PREVIOUS_LIST';

